/**
 * event-attendance.js
 */

import { Types } from 'utils/constants';


export const getAttendance = (isOptional, isAttending, endDate) => {
  if (isOptional === null && isAttending === null) return null;

  const now = new Date();
  if (!isOptional || isAttending) {
    return {
      id: Types.Attendance.ATTENDING,
      label: endDate && endDate < now ? 'Attended' : 'Attending',
      iconName: 'attending'
    };
  } else if (isOptional && isAttending === false) {
    return {
      id: Types.Attendance.NOT_ATTENDING,
      label: endDate && endDate < now ? 'Not Attended' : 'Not Attending',
      iconName: 'not-attending'
    };
  } else {
    return {
      id: Types.Attendance.UNDECIDED,
      label: 'Undecided',
      iconName: 'undecided'
    };
  }
}